<template>
    <div class="strategy-edit-model">
        <TitleBaseBox :title="title" class="model-wrap" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="model-content">
                <ItemPanel :text="editConfig.strategyPlatform">
                    <IconInput
                        class="model-input"
                        :initValue="platformTitle"
                        @inputChange="platformTitleChange"
                        :placeholder="editConfig.namePlaceholder"
                    ></IconInput>
                </ItemPanel>
                <ItemPanel :text="editConfig.strategyName" :isRequired="true">
                    <IconInput
                        class="model-input"
                        :initValue="strategyName"
                        @inputChange="nameChange"
                        :placeholder="editConfig.namePlaceholder"
                    ></IconInput>
                </ItemPanel>
                <ItemPanel :text="editConfig.strategyTag" :isRequired="true">
                    <TagSelect
                        class="model-tag-select"
                        :placeholder="editConfig.tagPlaceholder"
                        :selected="strategyTag"
                        @clickSelect="selectHandler"
                    ></TagSelect>
                </ItemPanel>
                <ItemPanel :text="editConfig.guideLang" :isRequired="true">
                    <LangSelect :value="initLang" class="lang-select" @change="langChange"></LangSelect>
                </ItemPanel>
                <ItemPanel :text="editConfig.strategyLabel">
                    <IconInput
                        class="model-input"
                        :initValue="strategyLabel"
                        @inputChange="strategyLabelChange"
                        :placeholder="editConfig.labelHolder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.playNumber">
                    <IconInput
                        class="model-input"
                        :initValue="playNumber"
                        @inputChange="playNumberChange"
                        :placeholder="editConfig.playNumberHolder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.likeNumber">
                    <IconInput
                        class="model-input"
                        :initValue="likeNumber"
                        @inputChange="likeNumberChange"
                        :placeholder="editConfig.likeNumberHolder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.showDate">
                    <el-date-picker
                        v-model="showDate"
                        type="date"
                        class="date-pick"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :placeholder="editConfig.showDateHolde"
                    >
                    </el-date-picker>
                </ItemPanel>

                <ItemPanel :text="editConfig.strategyCover" :isRequired="true">
                    <CoverPanel
                        class="image-upload"
                        :noCoverIcon="editConfig.noCoverIcon"
                        :imageUrl="cardImage"
                        :operateIcons="editConfig.operateIcons"
                        :viewIcon="editConfig.viewIcon"
                        ishorizontal="true"
                        @uploadCover="uploadCover"
                        @operatorSelect="operatorSelect"
                    />
                </ItemPanel>
                <div>
                    <ItemPanel :text="editConfig.strategyContent" :isRequired="true"></ItemPanel>
                    <GuidePanel :widget="guideContent" @guideDataHandle="guideDataHandle" />
                </div>
                <div class="creator-info" v-if="isEditStatus">
                    <div>
                        <p>{{ $t("zhiji.common.creator") }}：{{ this.data.strategyData.creator }}</p>
                        <p>{{ $t("zhiji.materialLibrary.updater") }}：{{ this.data.strategyData.editor }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.common.createTime") }}：{{ this.data.strategyData.createTime }}</p>
                        <p>{{ $t("zhiji.materialLibrary.updateTime") }}：{{ this.data.strategyData.updateTime }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.materialLibrary.type") }}：{{ this.data.strategyData.sourceType | conversionType }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.materialLibrary.reading") }}：{{ this.data.strategyData.amount }}</p>
                    </div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import { ParamError } from "@/views/zhiji/js/common/errors.js";

import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import TagSelect from "@/views/zhiji/components/materialLibrary/TagSelect";
import ItemPanel from "@/views/zhiji/components/materialLibrary/ItemPanel";
import CoverPanel from "@/views/zhiji/components/questionEdit/answers/widgets/CoverPanel";
import ImageClipModal from "@/views/zhiji/components/imageUpload/ImageClipModal";
import GuidePanel from "./guideContents/GuidePanel";
import LangSelect from "@/components/langSelect";
import { editModalConfig } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "TextGuidesEditModel",
    props: ["data"],
    components: {
        TitleBaseBox,
        ItemPanel,
        IconInput,
        CoverPanel,
        TagSelect,
        GuidePanel,
        LangSelect
    },
    data() {
        const defaultLang = this.$store.state.zhiji.gameState.defaultLang || "";
        return {
            platformTitle: this.data.strategyData.platformTitle || "",
            strategyName: this.data.strategyData.title || "",
            strategyTag: this.data.strategyData.tagIds || "",
            cardImage: this.data.strategyData.url || "",
            guideContent: this.data.strategyData.content || "",
            isEditStatus: this.data.type == "edit" ? true : false,
            initLang: this.data.strategyData.lang || defaultLang,
            strategyLabel: this.data.strategyData.strategyLabel || "",
            playNumber: this.data.strategyData.playNumber || "",
            likeNumber: this.data.strategyData.likeNumber || "",
            showDate: this.data.strategyData.showDate || ""
        };
    },
    computed: {
        title() {
            return this.data.type == "add" ? this.$t("zhiji.materialLibrary.addGuides") : this.$t("zhiji.materialLibrary.editGuides");
        },
        editConfig() {
            return editModalConfig();
        }
    },
    filters: {
        conversionType(val) {
            let types = {
                0: "VLink"
            };
            return types[val];
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.materialLibraryPage[propName];
        },
        selectHandler(data) {
            this.strategyTag = data;
        },
        langChange(newVal) {
            this.initLang = newVal;
        },
        nameChange(newVal) {
            this.strategyName = newVal;
        },
        platformTitleChange(newVal) {
            this.platformTitle = newVal;
        },
        strategyLabelChange(newVal) {
            this.strategyLabel = newVal;
        },
        playNumberChange(newVal) {
            this.playNumber = newVal;
        },
        likeNumberChange(newVal) {
            this.likeNumber = newVal;
        },
        uploadCover() {
            this.uploadImage(imageUrl => {
                this.cardImage = imageUrl;
            });
        },
        operatorSelect(type) {
            if (type == "update") {
                this.uploadImage(imageUrl => {
                    this.cardImage = imageUrl;
                });
            }
        },
        uploadImage(cb) {
            this.$store.commit("zhiji/showModal", {
                type: ImageClipModal,
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: true,
                    aspectRatio: 4 / 3
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            !this.data.childModel && this.close();
        },
        confirmClick() {
            let checkedData = {
                strategyName: this.strategyName,
                guideContent: this.guideContent,
                cardImage: this.cardImage,
                strategyTag: this.strategyTag
            };
            new Promise(function(resolve) {
                checkGuidesData(checkedData);
                resolve();
            })
                .then(() => {
                    this.saveGuidesData();
                })
                .catch(err => {
                    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: err.message
                            }
                        });
                    }
                });
        },
        saveGuidesData() {
            let handler = {
                add: this.addGuides,
                edit: this.editGuides
            };
            handler[this.data.type].call(null);
        },
        addGuides() {
            this.zhiji
                .requestByServiceName("addVLinkGuides", {
                    platformTitle: this.platformTitle,
                    strategyName: this.strategyName,
                    guideContent: this.guideContent,
                    cardImage: this.cardImage,
                    strategyTag: this.strategyTag,
                    lang: this.initLang,
                    strategyLabel: this.strategyLabel,
                    playNumber: this.playNumber,
                    likeNumber: this.likeNumber,
                    showDate: this.showDate
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.close();
                });
        },
        editGuides() {
            this.zhiji
                .requestByServiceName("updateVLinkGuides", {
                    platformTitle: this.platformTitle,
                    strategyName: this.strategyName,
                    guideContent: this.guideContent,
                    cardImage: this.cardImage,
                    strategyTag: this.strategyTag,
                    id: this.data.strategyData.id,
                    lang: this.initLang,
                    strategyLabel: this.strategyLabel,
                    playNumber: this.playNumber,
                    likeNumber: this.likeNumber,
                    showDate: this.showDate
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.close();
                });
        },
        successTips(tipText) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipText,
                    cancel: () => {},
                    confirm: () => {}
                }
            });
        },
        guideDataHandle(data) {
            this.guideContent = data;
        }
    }
};

// 校验攻略参数
function checkGuidesData(data) {
    if (!data.strategyName) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.guidesNameRequired"));
    }

    if (!data.strategyTag) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.guidesTagRequired"));
    }

    if (!data.cardImage) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.guidesCoverRequired"));
    }

    data.guideContent.forEach(item => {
        if ((item.wtType === "GuidePicture" && !item.image) || (item.wtType === "GuideText" && !item.content)) {
            throw new ParamError(i18n.t("zhiji.materialLibrary.guidesContentRequired"));
        }
    });
}
</script>

<style lang="scss">
.strategy-edit-model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    .model-wrap {
        overflow-y: auto;
        .model-content {
            width: 860px;
            padding: 4px 4px 0 4px;
            font-size: 12px;
            box-sizing: border-box;
            .model-input {
                width: 600px;
                height: 32px;
                background: #ffffff;
                border: 0;
                & > input {
                    border-color: #d8e4f0;
                    border-radius: 4px;
                }
                & > input:focus {
                    border-color: #2088f3;
                }
            }
            .lang-select {
                width: 600px;
            }
            .model-tag-select {
                width: 600px;
            }
            .image-upload {
                width: 142px;
                height: 107px;
                margin-right: 4px;
                background: #fafbfd;
                border: 1px solid #d8e4f0;
                border-radius: 4px;
                .cover-image-panel {
                    border-radius: 4px;
                    overflow: hidden;
                    & > img {
                        max-width: none;
                    }
                }
            }
            .creator-info {
                width: 812px;
                margin-top: 16px;
                font-size: 12px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }
        .buttons {
            padding: 20px !important;
            background: #fafbfd;
            border-top: 1px solid #d8e4f0;
        }
    }

    .date-pick {
        border: 1px solid #d8e4f0;
        border-radius: 4px;
    }
}
</style>
